import {
  ChainTransactionStatus,
  KatanaPerpsOrderFill,
} from '@katanaperps/katana-perps-sdk';

import { ApiFill } from '#/api/types';

export const updateMinedFillInArray = (
  fills: ApiFill[],
  { fillId, txHash }: { fillId: string; txHash: string }
): ApiFill[] => {
  return fills.map(trade =>
    trade.fillId === fillId
      ? {
          ...trade,
          txStatus: ChainTransactionStatus.mined,
          txId: txHash,
        }
      : trade
  );
};

// Would be good to unite function with one above - typings issue
export const updateMinedOrderFillInArray = (
  fills: KatanaPerpsOrderFill[],
  { fillId, txHash }: { fillId: string; txHash: string }
): KatanaPerpsOrderFill[] => {
  return fills.map(trade =>
    trade.fillId === fillId
      ? {
          ...trade,
          txStatus: ChainTransactionStatus.mined,
          txId: txHash,
        }
      : trade
  );
};
